import React from 'react';
import { ButtonProps } from './button.interface';
import './button.style.scss';

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
    return (
        <button className="wom-button" onClick={props.onClick} style={props.style}>
            {props.children}
        </button>
    );
};

export default Button;
